var utils = require("../../utils/utils");
var dateHelper = require("../../utils/date_helpers");

var calendarArgumentsHelper = function(gantt){
	return {
		getWorkHoursArguments: function () {
			var config = arguments[0];
			if (dateHelper.isDate(config)) {
				config = {
					date: config
				};
			} else {
				config = utils.mixin({}, config);
			}
			return config;
		},
		setWorkTimeArguments: function () {
			return arguments[0];
		},
		unsetWorkTimeArguments: function () {
			return arguments[0];
		},
		isWorkTimeArguments: function () {
			var config = arguments[0];
			if (!config.date) {
				config = {};
				config.date = arguments[0];
				config.unit = arguments[1];
				config.task = arguments[2];
				config.calendar = arguments[3];
			} else {
				config = utils.mixin({}, config);
				config.unit = config.unit || gantt.config.duration_unit;
				config.task = config.task || null;
				config.calendar = config.calendar || null;
			}

			config.unit = config.unit || gantt.config.duration_unit;

			return config;
		},
		getClosestWorkTimeArguments: function (config) {
			config = arguments[0];
			if (dateHelper.isDate(config)) {
				config = {
					date: config
				};
			} else {
				config = utils.mixin({}, config);
			}
			config.dir = config.dir || 'any';
			config.unit = config.unit || gantt.config.duration_unit;

			return config;
		},

		getDurationConfig: function (start, end, task, calendar) {
			this.start_date = start;
			this.end_date = end;
			this.task = task;
			this.calendar = calendar;
			this.unit = null;
			this.step = null;
			return this;
		},
		_getStartEndConfig: function (param) {
			var argumentType = this.getDurationConfig;
			var config;
			if (param instanceof argumentType)
				return param;

			if (dateHelper.isDate(param)) {
				config = new argumentType(arguments[0], arguments[1], arguments[2], arguments[3]);
			} else {
				config = new argumentType(param.start_date, param.end_date, param.task);
				if (param.id) {
					config.task = param;
				}
			}

			config.unit = config.unit || gantt.config.duration_unit;
			config.step = config.step || gantt.config.duration_step;
			config.start_date = config.start_date || config.start || config.date;

			return config;
		},

		getDurationArguments: function (start, end, unit, step) {
			return this._getStartEndConfig.apply(this, arguments);
		},

		hasDurationArguments: function (start, end, unit, step) {
			return this._getStartEndConfig.apply(this, arguments);
		},

		calculateEndDateArguments: function (start, duration, unit, step) {
			var config = arguments[0];
			if (dateHelper.isDate(config)) {
				config = {
					start_date: arguments[0],
					duration: arguments[1],
					unit: arguments[2],
					task: arguments[3],
					calendar: arguments[4]
				};
			} else {
				config = utils.mixin({}, config);
			}

			config.unit = config.unit || gantt.config.duration_unit;
			config.step = config.step || gantt.config.duration_step;

			return config;
		}
	};
};


module.exports = calendarArgumentsHelper;


//////////////////
// WEBPACK FOOTER
// ./sources/core/worktime/calendar_arguments_helper.js
// module id = 18
// module chunks = 0